import { validation, yupObject } from 'utils/validation';

const { email, requiredPassword } = validation.accountFields;

export const validationSchema = yupObject({
  email,
  password: requiredPassword,
});
